export type RpGalleryAmplitudeLocation = "property_page" | "investment_page";
export type RpGalleryAmplitudeAuthPlacement = "rp_gallery_property" | "rp_gallery_investment";

export interface IRpGalleryAmplitudeContext {
    location: RpGalleryAmplitudeLocation;
    authPlacement: RpGalleryAmplitudeAuthPlacement;
}

const propertyPageContext: IRpGalleryAmplitudeContext = {location: "property_page", authPlacement: "rp_gallery_property"};
const investmentPageContext: IRpGalleryAmplitudeContext = {location: "investment_page", authPlacement: "rp_gallery_investment"};

export const getRpGalleryAmplitudeContext = (location: RpGalleryAmplitudeLocation): IRpGalleryAmplitudeContext =>
    location === "property_page" ? propertyPageContext : investmentPageContext;
export type RpGalleryAmplitudeLocation = "property_page" | "investment_page";
export type RpGalleryAmplitudeAuthPlacement = "rp_gallery_property" | "rp_gallery_investment";

export interface IRpGalleryAmplitudeContext {
    location: RpGalleryAmplitudeLocation;
    authPlacement: RpGalleryAmplitudeAuthPlacement;
}

const propertyPageContext: IRpGalleryAmplitudeContext = {location: "property_page", authPlacement: "rp_gallery_property"};
const investmentPageContext: IRpGalleryAmplitudeContext = {location: "investment_page", authPlacement: "rp_gallery_investment"};

export const getRpGalleryAmplitudeContext = (location: RpGalleryAmplitudeLocation): IRpGalleryAmplitudeContext =>
    location === "property_page" ? propertyPageContext : investmentPageContext;
